<template>
  <div class="main-content">
    <div class="manual-checkin-page">
      <div class="container">
        <div class="out-side">
          <h3 class="manual-checkin__title">會員手動報到</h3>
          <div class="single-input-field">
            <p class="input-title">會員電話</p>
            <div class="input-area">
              <div class="custom-input">
                <input
                  type="text"
                  class="custom-text account"
                  :placeholder="'請輸入會員電話'"
                  name="account"
                  :value="inputs['phone']"
                  autocomplete="off"
                  @input="onInputChange"
                  @focus="onInputFocus"
                  id="phone"
                />
              </div>

              <div class="outer">
                <div
                  class="far fa-keyboard"
                  data-id="phone"
                  @click="handleKeyboardShow"
                ></div>
              </div>
            </div>
          </div>

          <div class="single-input-field">
            <p class="input-title">密碼</p>
            <div class="input-area">
              <div class="custom-input">
                <input
                  :type="fieldType"
                  class="custom-text password"
                  :placeholder="'請輸入密碼'"
                  name="password"
                  :value="inputs['password']"
                  autocomplete="off"
                  @input="onInputChange"
                  @focus="onInputFocus"
                  id="password"
                />
                <div
                  class="icon-icon_sharp-1"
                  @click="changeToText"
                  v-show="fieldType == 'password'"
                ></div>

                <div
                  class="icon-icon_sharp"
                  @click="changeToPassword"
                  v-show="fieldType == 'text'"
                ></div>
              </div>
              <div class="outer">
                <div
                  class="far fa-keyboard"
                  data-id="password"
                  @click="handleKeyboardShow"
                ></div>
              </div>
            </div>
          </div>

          <SimpleKeyBoard
            @onChange="onChange"
            @onKeyPress="onKeyPress"
            @handleClose="handleClose"
            @handleClear="handleClear"
            :input="inputs[inputName]"
            :inputName="inputName"
            v-show="isKeyboardShow"
          />
        </div>
        <button class="custom-btn" @click="manualCheckIn()">確認報到</button>
      </div>
    </div>
    <CompleteCheckIn
      :id="1"
      @closeModal="toPrePage()"
      :course-checking-log="courseCheckingLog"
    />
    <UseFinished :id="1" @closeModal="toPrePage()" />
    <HaveAttend :id="1" @closeModal="toPrePage()" />
    <UnableCheckIn :id="1" @closeModal="toPrePage()" />
    <RepeatCheckIn :id="1" @closeModal="toPrePage()" />
    <CourseIsFull :id="1" @closeModal="toPrePage()" />
    <IsInLeave :id="1" @closeModal="toPrePage()" />
    <EnterAuthInvalid :id="1" />
  </div>
</template>

<script>
import moment from 'moment';
import SimpleKeyBoard from '@/components/SimpleKeyBoard/SimpleKeyBoard';
import { manualCheckIn } from '@/api/check_in_system';
import CompleteCheckIn from '@/components/Modal/CompleteCheckIn';
import UseFinished from '@/components/Modal/UseFinished';
import HaveAttend from '@/components/Modal/HaveAttend';
import UnableCheckIn from '@/components/Modal/UnableCheckIn';
import RepeatCheckIn from '@/components/Modal/RepeatCheckIn';
import CourseIsFull from '@/components/Modal/CourseIsFull';
import IsInLeave from '@/components/Modal/IsInLeave';
import EnterAuthInvalid from '@/components/Modal/EnterAuthInvalid';

export default {
  data() {
    return {
      fieldType: 'password',
      phone: '',
      password: '',
      nowFocus: '',
      inputs: {
        phone: '',
        password: ''
      },
      inputName: 'phone',
      isKeyboardShow: false,
      schedule_time_id: this.$route.params.schedule_time_id,
      courseCheckingLog: {}
    };
  },
  computed: {
    manualCheckInParams() {
      return {
        id: this.schedule_time_id,
        phone: this.inputs.phone,
        password: this.inputs.password,
        date: moment().format('YYYY-MM-DD')
      };
    }
  },
  components: {
    SimpleKeyBoard,
    CompleteCheckIn,
    UseFinished,
    HaveAttend,
    UnableCheckIn,
    RepeatCheckIn,
    CourseIsFull,
    IsInLeave,
    EnterAuthInvalid
  },
  methods: {
    //查看密碼
    changeToText() {
      this.fieldType = 'text';
    },

    //切換回密碼
    changeToPassword() {
      this.fieldType = 'password';
    },

    handleKeyboardShow(e) {
      this.isKeyboardShow = true;
      this.inputName = e.target.dataset.id;
    },

    handleClose() {
      this.isKeyboardShow = false;
    },

    onInputFocus(input) {
      this.inputName = input.target.id;
    },

    onChange(input) {
      this.inputs[this.inputName] = input;
    },
    onKeyPress() {},

    onInputChange(input) {
      this.inputs[input.target.id] = input.target.value;
    },

    handleClear() {
      this.inputs[this.inputName] = '';
    },
    toPrePage() {
      this.toNextPage('學員報到');
    },
    toNextPage(routeName) {
      this.$router.push({ name: routeName });
    },
    manualCheckIn() {
      manualCheckIn(
        this.manualCheckInParams,
        res => {
          this.showCompleteCheckinModal(res);
        },
        err => {
          switch (err) {
            case '40001':
              this.showUseFinished();
              break;
            case '40002':
              this.showHaveAttend();
              break;
            case '40003':
              this.showUnableCheckin();
              break;
            case '40004':
              this.showRepeatCheckin();
              break;
            case '40022':
              this.showCourseIsFull();
              break;
            case '40023':
              this.showIsInLeaveFull();
              break;
            default:
              this.showEnterAuthInvalid();
              break;
          }
        }
      );
    },
    showCompleteCheckinModal(courseCheckingLog) {
      this.courseCheckingLog = courseCheckingLog;

      this.$bvModal.show(`complete-checkin-modal1`);
    },
    showUseFinished() {
      this.$bvModal.show(`use-finished1`);
    },
    showHaveAttend() {
      this.$bvModal.show(`have-attend1`);
    },
    showUnableCheckin() {
      this.$bvModal.show(`unable-checkin1`);
    },
    showRepeatCheckin() {
      this.$bvModal.show(`repeat-checkin1`);
    },
    showCourseIsFull() {
      this.$bvModal.show(`course-is-full1`);
    },
    showIsInLeaveFull() {
      this.$bvModal.show(`is-in-leave1`);
    },
    showEnterAuthInvalid() {
      this.$bvModal.show(`enter-auth-invalid1`);
    }
  }
};
</script>
